import React from "react";
import moment from "moment";

interface NameWithDateProps {
  name?: string | null;
  date?: string | Date | null;
}

const NameWithDate: React.FC<NameWithDateProps> = ({ name, date }) => {
  return (
    <div style={{ lineHeight: "1.4" }}>
      <div>{name ?? "N/A"}</div>
      <div style={{ fontSize: "12px", color: "#6c757d" }}>
        {date ? moment(date).format("DD-MMM-YYYY") : "-"}
      </div>
    </div>
  );
};

export default NameWithDate;
